import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const operationPerformanceConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default operationPerformanceConfig;
